import { FC, Fragment, JSX } from 'react';
import { Box, Button, Card, CardActions, CardContent, Grid } from '@mui/material';
// components
import InputController from 'controller/InputController';
import DensitySelector from 'components/common/selectors/density';
import SupplierSelector from 'components/common/selectors/supplier';
import ProductSizeSelector from 'components/common/selectors/productSize';
import CapsuleTypeSelector from 'components/common/selectors/capsuleType';
// constants, styles, interfaces
import { ProductTypes } from 'generated/graphql';
import { CapsulePriceFormProps } from 'interfaces';
import { flexMarginTopEndCenter, forInputLabelBg } from 'styles/commonComponentStyle';
import {
  MG_TEXT,
  SAVE_TEXT,
  PRICE_TEXT,
  DENSITY_TEXT,
  SUPPLIER_TEXT,
  CAPACITY_TEXT,
  PER_1000_TEXT,
  CAPSULE_TYPE_TEXT,
  PRODUCT_SIZE_TEXT,
} from 'constants/index';

const CapsulePriceForm: FC<CapsulePriceFormProps> = ({ isEdit = false, loading = false }): JSX.Element => {
  return (
    <Card sx={forInputLabelBg}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={12}>
            <InputController
              isRequired
              name="capacity"
              fieldType="number"
              disabled={loading}
              title={`${CAPACITY_TEXT} (${MG_TEXT})`}
            />
          </Grid>

          <Grid item xs={12} lg={12}>
            <InputController
              isRequired
              name="price"
              fieldType="number"
              disabled={loading}
              title={`${PRICE_TEXT} ${PER_1000_TEXT}`}
            />
          </Grid>

          <Grid item xs={12} lg={12}>
            <SupplierSelector isRequired name="supplier" disabled={loading} title={SUPPLIER_TEXT} />
          </Grid>

          <Grid item xs={12} lg={12}>
            <ProductSizeSelector
              isRequired
              name="productSize"
              disabled={loading}
              title={PRODUCT_SIZE_TEXT}
              productType={ProductTypes.Capsule}
            />
          </Grid>

          <Grid item xs={12} lg={12}>
            <CapsuleTypeSelector isRequired name="capsuleType" disabled={loading} title={CAPSULE_TYPE_TEXT} />
          </Grid>

          <Grid item xs={12} lg={12}>
            <DensitySelector isRequired name="density" disabled={loading} title={DENSITY_TEXT} />
          </Grid>
        </Grid>
      </CardContent>

      {isEdit ? (
        <CardActions>
          <Box sx={flexMarginTopEndCenter}>
            <Button type="submit" variant="contained" size="small" disabled={loading}>
              {SAVE_TEXT}
            </Button>
          </Box>
        </CardActions>
      ) : (
        <Fragment />
      )}
    </Card>
  );
};

export default CapsulePriceForm;
